// Import React normally since we're ensuring it's available globally through our scripts
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import App from "./App";
import "./index.css";
import { Toaster } from "@/components/ui/sonner";

// Environment variable checks
if (!import.meta.env.VITE_SUPABASE_URL) {
  console.warn("Missing VITE_SUPABASE_URL environment variable");
}

if (!import.meta.env.VITE_SUPABASE_ANON_KEY) {
  console.warn("Missing VITE_SUPABASE_ANON_KEY environment variable");
}

if (!import.meta.env.VITE_API_URL) {
  console.warn("Missing VITE_API_URL environment variable");
}

const rootElement = document.getElementById("root");

if (!rootElement) {
  console.error("Root element not found");
} else {
  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
      <Router>
        <AuthProvider>
          <App />
          <Toaster />
        </AuthProvider>
      </Router>
    </React.StrictMode>
  );
}
